/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, December 4th 2022, 1:14:46 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { CUSTOMER_SERVICE_EMAIL } from "config";
import { DebugIcon } from "theme/icons";
import { FullScreenNotificationGrid } from "ui-widgets";

export const UndefinedOrganizationStatusAlert = ({ organizationName }) => {
  return (
    <FullScreenNotificationGrid
      pageTitle={<>Could not determine Organization status</>}
      pageContent={
        <p>
          We could not get the status of your organization. Please refresh the page. If the problem persists, contact{" "}
          <a href={`mailto:${CUSTOMER_SERVICE_EMAIL}`}>{CUSTOMER_SERVICE_EMAIL}</a>
        </p>
      }
      pageIllustration={<DebugIcon height={256} width={256} />}
    />
  );
};
